export const APP_TYPE = 'gempagesv7';
export const PLATFORM = 'SHOPIFY';
export const SHOP_STATUS = 'CONNECTED';
export const NUMBER_OF_REFRESH = 5;
